module.exports = __webpack_public_path__ + "img/diagram_17_1.ccee9760.png";